import React from "react";

const MyHistory = () => {
  return (
    <div>
      <h2>This is my treatment History</h2>
    </div>
  );
};

export default MyHistory;
